var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.template,_vm._g(_vm._b({tag:"component",class:[
    { '--no-padding-bottom': _vm.noPaddingBottom || _vm.isCypress() },
    'app-page'
  ]},'component',_vm.props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }